import { useIntl } from 'react-intl';

import { useSelector } from '_common/hooks';
import { selectIsIEnvision } from 'App/redux/appSlice';

import { Paragraph } from '@ets/design-system';

const IEnvisionLabel = () => {
  const intl = useIntl();
  const isIEnvision = useSelector(selectIsIEnvision);

  if (!isIEnvision) {
    return null;
  }

  return (
    <Paragraph
      size="s"
      className="text-neutral-70 ml-4 overflow-hidden text-ellipsis whitespace-nowrap"
    >
      {intl.formatMessage({ id: 'OPENED_THROUGH_IENVISION' })}
    </Paragraph>
  );
};

export default IEnvisionLabel;
